import type { ReactNode } from 'react';

import { cn } from '@shared/lib/utils';
import { Text } from '../typography/text';

export interface DescriptionListItem {
  id: string;
  term: ReactNode;
  description: ReactNode;
}

export interface DescriptionListProps {
  items: readonly DescriptionListItem[];
  columns?: 1 | 2;
  mobileLayout?: 'stacked' | 'inline';
  /** Give field labels half of the desktop row when localized terms need more room. */
  termWidth?: 'default' | 'wide';
  className?: string;
}

export function DescriptionList({
  items,
  columns = 2,
  mobileLayout = 'stacked',
  termWidth = 'default',
  className,
}: DescriptionListProps) {
  return (
    <dl className={cn('grid min-w-0 gap-x-6', columns === 2 ? 'lg:grid-cols-2' : null, className)}>
      {items.map((item) => (
        <div
          key={item.id}
          className={cn(
            'grid min-w-0 py-1 sm:items-baseline sm:gap-4',
            termWidth === 'wide' ? 'sm:grid-cols-2' : 'sm:grid-cols-3',
            mobileLayout === 'inline' ? 'grid-cols-2 items-baseline gap-4' : 'gap-1'
          )}
        >
          <dt className="min-w-0">
            <Text
              as="span"
              size="sm"
              color="fieldLabel"
              className="block min-w-0 break-words"
              data-description-list-label
            >
              {item.term}
            </Text>
          </dt>
          <dd className={cn('min-w-0', termWidth === 'wide' ? 'sm:col-span-1' : 'sm:col-span-2')}>
            <Text
              as="div"
              size="sm"
              className="min-w-0 break-words font-medium"
              data-description-list-value
            >
              {item.description}
            </Text>
          </dd>
        </div>
      ))}
    </dl>
  );
}
